import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import Transaction from '@/ts/Transaction';

@Module({name: 'UserWallet', namespaced: true})
export default class UserWallet extends VuexModule {
    public transactions: any = [];
    public activeTransaction: Transaction = null;
    public choosePaymentMethodBlocKVisibility: boolean = false;
    public showPayForOrderModalVisibility: boolean = false;
    public orderPaySuccessModalVisibility: boolean = false;
    public orderPayFailureModalVisibility: boolean = false;
    public showWalletBlock: boolean = true;
    public showCreditCardsBlock: boolean = false;
    public showTransactionsBlock: boolean = false;


    get getShowWalletBlock(): boolean {
        return this.showWalletBlock;
    }
    get getShowCreditCardsBlock(): boolean {
        return this.showCreditCardsBlock;
    }
    get getShowTransactionsBlock(): boolean {
        return this.showTransactionsBlock;
    }

    get getTransactions(): any {
        return this.transactions;
    }

    get getActiveTransaction(): Transaction {
        return this.activeTransaction;
    }

    get getChoosePaymentMethodBlocKVisibility(): boolean {
        return this.choosePaymentMethodBlocKVisibility;
    }

    get getPayForOrderModalVisibility(): boolean {
        return this.showPayForOrderModalVisibility;
    }

    get getOrderPaySuccessModalVisibility(): boolean {
        return this.orderPaySuccessModalVisibility;
    }

    get getOrderPayFailureModalVisibility(): boolean {
        return this.orderPayFailureModalVisibility;
    }


    @Mutation
    public SET_SHOW_WALLET_BLOCK_VISIBILITY(status: boolean) {
        this.showWalletBlock = status;
    }

    @Mutation
    public SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY(status: boolean) {
        this.showCreditCardsBlock = status;
    }

    @Mutation
    public SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY(status: boolean) {
        this.showTransactionsBlock = status;
    }

    @Mutation
    public SET_PAY_FOR_ORDER_MODAL_VISIBILITY(status: boolean) {
        this.showPayForOrderModalVisibility = status;
    }

    @Mutation
    public SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY(status: boolean) {
        this.orderPaySuccessModalVisibility = status;
    }

    @Mutation
    public SET_ORDER_PAY_FAILURE_MODAL_VISIBILITY(status: boolean) {
        this.orderPayFailureModalVisibility = status;
    }

    @Mutation
    public SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY(status: boolean) {
        this.choosePaymentMethodBlocKVisibility = status;
    }

    @Mutation
    public UPDATE_ACTIVE_TRANSACTION(transaction: any) {
            this.activeTransaction = new Transaction(
                transaction.externalId,
                transaction.date,
                transaction.orderDate,
                transaction.orderType,
                transaction.orderId,
                transaction.orderAmount,
                transaction.unitId,
                transaction.unitTitle,
                transaction.unitAddress,
                transaction.additionalData,
                transaction.orderDescription,
                transaction.paymentMethod,
                transaction.paymentStatus,
                transaction.currency,
                transaction.tenantName,
                transaction.tenantId,
                transaction.project,
                transaction.paymentDate,
                transaction.totalAmount,
                transaction.vatAmount,
                transaction.id,
            );

    }


    @Mutation
    public SET_USER_TRANSACTIONS(transactions: any) {
        this.transactions = [];
        for (const transaction of transactions) {
            this.transactions.push(new Transaction(
                transaction.externalId,
                transaction.date,
                transaction.orderDate,
                transaction.orderType,
                transaction.orderId,
                transaction.orderAmount,
                transaction.unitId,
                transaction.unitTitle,
                transaction.unitAddress,
                transaction.additionalData,
                transaction.orderDescription,
                transaction.paymentMethod,
                transaction.paymentStatus,
                transaction.currency,
                transaction.tenantName,
                transaction.tenantId,
                transaction.project,
                transaction.paymentDate,
                transaction.totalAmount,
                transaction.vatAmount,
                transaction.id,
            ));
        }

    }


    @Action
    public FETCH_USER_TRANSACTIONS(type: any) {
        axios.get(Endpoints.Finances.USER_TRANSACTIONS(type))
            .then((response) => {
                store.commit(Mutations.SET_USER_TRANSACTIONS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ADD_USER_CREDIT_CARDS(card: any) {
        axios.post(Endpoints.Finances.ADD_USER_CREDIT_CARDS, card)
            .then((response) => {
                store.commit(Mutations.ADD_CREDIT_CARD, card);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }


    @Action
    public FETCH_TRANSACTION(transactionId: any) {
        axios.get(Endpoints.Finances.FETCH_TRANSACTION(transactionId))
            .then((response) => {
                store.commit(Mutations.UPDATE_ACTIVE_TRANSACTION, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_USER_CREDIT_CARDS(cardIndex: number) {
        store.commit(Mutations.REMOVE_CREDIT_CARD, cardIndex);
    }
}
